/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '../services/environment.service';
import { Store } from '@ngrx/store';
import { selectUserDataForPendo } from '../../user/+state/user.selectors';
import { filter, map } from 'rxjs/operators';
import { IPendo, NGX_PENDO_CONTEXT } from 'ngx-pendo';
import { take } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PendoService {
    private _pendo = inject(NGX_PENDO_CONTEXT);

    constructor(
        private env: EnvironmentService,
        private store: Store
    ) {
        if (this._pendo) {
            this.initialize();
        }
    }

    get pendo(): IPendo {
        return this._pendo;
    }

    private initialize() {
        this.store
            .select(selectUserDataForPendo)
            .pipe(
                filter((data) => !!data),
                take(1),
                map((data) => this.getPendoBaseParams(data))
            )
            .subscribe(async (params) => {
                this._pendo.updateOptions(params);
                this._pendo.initialize({
                    dataHost: 'https://data.activity.commandcentral.com',
                    contentHost: 'https://content.activity.commandcentral.com',
                    visitor: params.visitor,
                    account: params.account
                });
            });
    }

    private getPendoBaseParams({ account, visitor }) {
        return {
            visitor: {
                application: 'VESTA NXT',
                environment: this.getEnvironmentName(),
                deployment_type: this.env.environment.IS_CLOUD_ENVIRONMENT ? 'Cloud' : 'Private Cloud',
                ...visitor
            },
            account: {
                application: 'VESTA NXT',
                environment: this.getEnvironmentName(),
                deployment_type: this.env.environment.IS_CLOUD_ENVIRONMENT ? 'Cloud' : 'Private Cloud',
                ...account
            }
        };
    }

    public getEnvironmentName(): string {
        return this.env.environment.ENVIRONMENT ? this.env.environment.ENVIRONMENT.replace('apollo-', '') : 'development';
    }
}
